module.exports = __webpack_public_path__ + "img/signal3.8767ea8b.svg";